import { MapPin, Mail, CreditCard, Database, Landmark, Smartphone, Building2 } from 'lucide-react';

export const SETTINGS_GROUPS = [
  {
    id: 'integrations',
    label: 'Integrations',
    items: [
      {
        id: 'maps',
        label: 'Google Maps',
        description: 'Venue search & places',
        icon: MapPin
      }
    ]
  },
  {
    id: 'email',
    label: 'Email',
    items: [
      {
        id: 'mail',
        label: 'SMTP settings',
        description: 'Ticket & order emails',
        icon: Mail,
        requiresSuperAdmin: true
      }
    ]
  },
  {
    id: 'payments',
    label: 'Payments',
    items: [
      {
        id: 'payments',
        label: 'Default payment method',
        description: 'Daraja, Family Bank, or NCBA',
        icon: CreditCard,
        requiresAdmin: true
      },
      {
        id: 'mpesa-daraja',
        label: 'M-Pesa Daraja STK',
        description: 'Safaricom credentials & callback',
        icon: Smartphone,
        requiresSuperAdmin: true
      },
      {
        id: 'family-bank',
        label: 'Family Bank STK',
        description: 'Credentials & callback URL',
        icon: Landmark,
        requiresSuperAdmin: true
      },
      {
        id: 'ncba-till',
        label: 'NCBA Till STK',
        description: 'Till credentials & bank letter',
        icon: Building2,
        requiresSuperAdmin: true
      }
    ]
  },
  {
    id: 'system',
    label: 'System',
    items: [
      {
        id: 'backup',
        label: 'Site & database backup',
        description: 'Full zip export',
        icon: Database,
        requiresSuperAdmin: true
      }
    ]
  }
];

export const DEFAULT_SETTINGS_SECTION = 'maps';

export function getVisibleSettingsSections({ isAdmin, isSuperAdmin }) {
  return SETTINGS_GROUPS.map((group) => ({
    ...group,
    items: group.items.filter((item) => {
      if (item.requiresSuperAdmin) return isSuperAdmin;
      if (item.requiresAdmin) return isAdmin;
      return true;
    })
  })).filter((group) => group.items.length > 0);
}

export function findSectionById(sectionId, { isAdmin, isSuperAdmin } = {}) {
  const groups = isAdmin !== undefined
    ? getVisibleSettingsSections({ isAdmin, isSuperAdmin })
    : SETTINGS_GROUPS;

  for (const group of groups) {
    const item = group.items.find((i) => i.id === sectionId);
    if (item) return { ...item, groupLabel: group.label };
  }
  return null;
}
